import { Input, Radio } from 'antd';
import { FC } from 'react';
import {
	isValidCpf,
	maskCpf,
	sanitizeCpf,
} from '../../../../../lib/utils/cpfValidator';
import { Nationality } from '../dto/SearchTagDto';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface IProps {
	nationality: Nationality;
	onNationalityChange: (n: Nationality) => void;
	document: string;
	onDocumentChange: (value: string) => void;
	email: string;
	onEmailChange: (value: string) => void;
	cpfCheckLoading?: boolean;
	cpfConflictTitle?: string | null;
	disabled?: boolean;
}

export const AuthorExtraFields: FC<IProps> = ({
	nationality,
	onNationalityChange,
	document,
	onDocumentChange,
	email,
	onEmailChange,
	cpfCheckLoading,
	cpfConflictTitle,
	disabled,
}) => {
	const isBR = nationality === 'Brasileiro';
	const sanitizedCpf = isBR ? sanitizeCpf(document) : '';
	const cpfFilled = isBR && sanitizedCpf.length > 0;
	const cpfFormatValid =
		isBR && sanitizedCpf.length === 11 && isValidCpf(sanitizedCpf);
	const emailInvalid = email.length > 0 && !EMAIL_REGEX.test(email);

	return (
		<>
			<div className='mt-4'>
				<label className='mr-4 font-semibold'>
					<span className='text-red-500'> * </span>NACIONALIDADE:
				</label>
				<div className='mt-2'>
					<Radio.Group
						value={nationality}
						onChange={(e) => onNationalityChange(e.target.value)}
						disabled={disabled}
					>
						<Radio value='Brasileiro'>Brasileiro</Radio>
						<Radio value='Estrangeiro'>Estrangeiro</Radio>
					</Radio.Group>
				</div>
			</div>

			<div className='mt-4'>
				<label className='mr-4 font-semibold'>
					{isBR && <span className='text-red-500'> * </span>}
					{isBR ? 'CPF:' : 'DOCUMENTO (opcional):'}
				</label>
				<div className='w-5/6'>
					<Input
						value={isBR ? maskCpf(document) : document}
						onChange={(e) =>
							onDocumentChange(
								isBR ? maskCpf(e.target.value) : e.target.value
							)
						}
						placeholder={isBR ? '000.000.000-00' : 'Documento'}
						maxLength={isBR ? 14 : 100}
						allowClear
						disabled={disabled}
					/>
				</div>
				{isBR && (
					<div className='mt-2 text-sm'>
						{cpfCheckLoading && (
							<span style={{ color: '#888' }}>Verificando CPF...</span>
						)}
						{!cpfCheckLoading && cpfFilled && !cpfFormatValid && (
							<span style={{ color: '#d4380d' }}>CPF inválido.</span>
						)}
						{!cpfCheckLoading && cpfConflictTitle && (
							<span style={{ color: '#d4380d' }}>
								Já existe um autor cadastrado com este CPF:{' '}
								{cpfConflictTitle}.
							</span>
						)}
						{!cpfCheckLoading &&
							cpfFilled &&
							cpfFormatValid &&
							!cpfConflictTitle && (
								<span style={{ color: '#52c41a' }}>
									CPF disponível.
								</span>
							)}
					</div>
				)}
			</div>

			<div className='mt-4'>
				<label className='mr-4 font-semibold'>
					{!isBR && <span className='text-red-500'> * </span>}
					EMAIL{isBR ? ' (opcional)' : ''}:
				</label>
				<div className='w-5/6'>
					<Input
						value={email}
						onChange={(e) => onEmailChange(e.target.value)}
						placeholder='email@dominio.com'
						allowClear
						disabled={disabled}
					/>
				</div>
				{emailInvalid && (
					<div className='mt-2 text-sm' style={{ color: '#d4380d' }}>
						Email inválido.
					</div>
				)}
			</div>
		</>
	);
};
